import { i18n } from "../src/plugins/i18n";

const content = {
  page_title: "Scavenger H₂",
  Status: {
    0: "Not Ready",
    1: "Error",
    2: "Ready H₂ readings valid (old data)",
    3: "Ready H₂ readings valid (new data)",
  },
  Operation: {
    0: "Undetermined",
    1: "H₂ measurement cycle",
    2: "Liquid temp meas cycle",
    3: "Auto calibration cycle",
    4: "Liquid temp too high",
  },
  h2_table: [
    {
      text: "",
      sortable: false,
      of_type: "indicator",
      valueOf: "hasIssues",
    },
    {
      text: i18n.t("views.ScavengerH2.tables.devices.columns.xfmrId.text"),
      value: "AssetID",
      of_type: "modal",
      identifier: "DeviceID",
    },
    {
      text: i18n.t("views.ScavengerH2.tables.devices.columns.h2Level.text"),
      value: "H2Lvl",
      of_type: "tooltip",
    },
    {
      text: i18n.t("views.ScavengerH2.tables.devices.columns.site.text"),
      value: "SiteName",
      of_type: "text",
    },
    {
      text: i18n.t("views.ScavengerH2.tables.devices.columns.oilType.text"),
      value: "OilType",
      of_type: "text",
    },
    {
      text: i18n.t("views.ScavengerH2.tables.devices.columns.opMode.text"),
      value: "OpMode",
      of_type: "text",
    },
    {
      text: i18n.t("views.ScavengerH2.tables.devices.columns.lastReading.text"),
      value: "LastMessageTime",
      of_type: "epoch",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails"],
      labels: ["Edit Details"],
    },
  ],
  scavenger_charts: {
    RMSVoltage: {
      id: "RMSVoltage",
      label: "RMS Voltage",
      values: ["L1", "L2", "L3"],
      yAxis: "RMS Voltage",
      suffix: "V",
      nom: 230,
      min: 207,
      max: 253,
      show: true,
      feeder: false,
      category: "pq",
    },
    ActivePower: {
      id: "ActivePower",
      label: "Active Power",
      values: ["L1", "L2", "L3"],
      yAxis: "Active Power",
      suffix: "kW",
      show: true,
      feeder: true,
      category: "pq",
    },
    ReactivePower: {
      id: "ReactivePower",
      label: "Reactive Power",
      values: ["L1", "L2", "L3"],
      yAxis: "Reactive Power",
      suffix: "kVAr",
      show: true,
      feeder: true,
      category: "pq",
    },
    ApparentPower: {
      id: "ApparentPower",
      label: "Apparent Power",
      values: ["L1", "L2", "L3"],
      yAxis: "Apparent Power",
      suffix: "kVA",
      show: true,
      feeder: true,
      category: "pq",
    },
    Temperature: {
      id: "SensorTemperature",
      label: "Temperature",
      values: ["Ambient", "Internal"],
      yAxis: "Temperature",
      suffix: "F",
      show: true,
      category: "pq",
    },
    H2: {
      id: "H2ppmCrt",
      label: "Hydrogen",
      values: [null],
      yAxis: "Hydrogen",
      suffix: "ppm",
      max: 5800,
      nom: 4000,
      average_threshold: true,
      show: true,
      category: "h2",
    },
    OilTemperature: {
      id: "TempOil",
      label: "Oil Temperature",
      values: [null],
      yAxis: "Oil Temperature",
      suffix: "F",
      max: 130,
      nom: 120,
      average_threshold: true,
      show: true,
      category: "h2",
    },
    AmbientTemperature: {
      id: "AmbientTemperature",
      label: "Ambient Temperature",
      values: [null],
      yAxis: "Ambient Temperature",
      suffix: "F",
      show: false,
      category: "ambient_temperature",
    },
    Current: {
      id: "Current",
      label: "Current",
      values: ["L1", "L2", "L3"],
      yAxis: "Current",
      suffix: "A",
      show: true,
      feeder: true,
      category: "pq",
    },
    Frequency: {
      id: "Frequency",
      label: "Frequency",
      values: [null],
      yAxis: "Frequency",
      suffix: "Hz",
      show: true,
      feeder: false,
      category: "pq",
    },
  },
  h2_charts: [
    {
      id: "hydrogen",
      label: i18n.t("views.ScavengerH2Details.charts.h2Charts.h2LevelandOilTemperature.label"),
      label_daily_stats: i18n.t("views.ScavengerH2Details.charts.h2Charts.h2LevelandOilTemperature.label_daily_stats"),
      seriesType: "lines",
      xAxis: i18n.t("views.ScavengerH2Details.charts.h2Charts.h2LevelandOilTemperature.xAxis"),
      yAxis: i18n.t("views.ScavengerH2Details.charts.h2Charts.h2LevelandOilTemperature.yAxis"),
      colors: ["#a1c7e2ee", "#e4592cee", "#1b428bee", "#52a0d2", "#f7af5d"],
      areaColors: ["#a1c7e2aa", "#e4592caa", "#1b428baa", "#52a0d2", "#f7af5d"],
      max: 5800,
      nom: 4000,
      dataLimit: 1,
      alert_limit: true,
      average_threshold: true,
    },
    {
      id: "oil_temperature",
      label: "Liquid Temperature",
      label_daily_stats: i18n.t("views.ScavengerH2Details.charts.h2Charts.liquidTemperature.label_daily_stats"),
      seriesType: "lines",
      xAxis: i18n.t("views.ScavengerH2Details.charts.h2Charts.liquidTemperature.xAxis"),
      yAxis: i18n.t("views.ScavengerH2Details.charts.h2Charts.liquidTemperature.yAxis"),
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      areaColors: ["#a1c7e2aa", "#e4592caa", "#1b428baa", "#52a0d2", "#f7af5d"],
      max: 130,
      nom: 120,
      dataLimit: 1,
      marginFactor: 0.3,
      average_threshold: true,
    },
  ],
  h2_longer_period_charts: [
    {
      id: "hydrogen",
      label: i18n.t("views.ScavengerH2Details.charts.h2LongerPeriodCharts.h2LevelandOilTemperature.label"),
      label_daily_stats: i18n.t(
        "views.ScavengerH2Details.charts.h2LongerPeriodCharts.h2LevelandOilTemperature.label_daily_stats"
      ),
      seriesType: "lines",
      xAxis: i18n.t("views.ScavengerH2Details.charts.h2LongerPeriodCharts.h2LevelandOilTemperature.xAxis"),
      yAxis: i18n.t("views.ScavengerH2Details.charts.h2LongerPeriodCharts.h2LevelandOilTemperature.yAxis"),
      colors: ["#a1c7e2ee", "#e4592cee", "#1b428bee", "#52a0d2", "#f7af5d"],
      areaColors: ["#a1c7e2aa", "#e4592caa", "#1b428baa", "#52a0d2", "#f7af5d"],
      max: 5800,
      nom: 4000,
      dataLimit: 1,
      alert_limit: true,
      average_threshold: true,
    },
  ],
  chart_select: [
    {
      id: "day",
      label: i18n.t("common.times.time.day"),
      value: "1",
      stringValue: "Day",
    },
    {
      id: "week",
      label: i18n.t("common.times.time.lastWeek"),
      value: "7",
      stringValue: "Week",
    },
    {
      id: "month",
      label: "Last Month",
      value: "30",
      stringValue: "Month",
    },
    {
      id: "3month",
      label: "Last 3 Months",
      value: "90",
      stringValue: "3 Months",
    },
    {
      id: "6month",
      label: "Last 6 Months",
      value: "180",
      stringValue: "6 Months",
    },
    {
      id: "year",
      label: "Last Year",
      value: "365",
      stringValue: "Year",
    },
  ],
  latest_message_h2: [
    {
      label: i18n.t("views.ScavengerH2Details.latestMessage.labels.h2Level.label"),
      values: ["H2Lvl"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-chart-line-variant",
      suffix: "ppm",
      type: "lookup",
      round: -1,
      pow: true,
    },
    {
      label: i18n.t("views.ScavengerH2Details.latestMessage.labels.oilTemperature.label"),
      values: ["OilTemp"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-thermometer-low",
      suffix: "F",
      type: "lookup",
      round: 1,
    },
  ],
  h2_overview: [
    {
      id: "alarm",
      title: "alarm",
      icon: "mdi-alarm-light-outline",
      backgroundColor: "alarmBackground",
      textColor: "alarmText",
      value: i18n.t("views.ScavengerH2.tabs.alarm.label"),
      tooltip: "",
    },
    {
      id: "caution",
      title: "caution",
      icon: "mdi-alert-outline",
      backgroundColor: "cautionBackground",
      textColor: "cautionText",
      value: i18n.t("views.ScavengerH2.tabs.caution.label"),
      tooltip: "",
    },
    {
      id: "check",
      title: "check",
      icon: "mdi-alert-circle-outline",
      backgroundColor: "checkDeviceBackground",
      textColor: "checkDeviceText",
      value: i18n.t("views.ScavengerH2.tabs.checkDevice.label"),
      tooltip: "",
    },
    {
      id: "noIssues",
      title: "noIssues",
      icon: "mdi-check-circle-outline",
      backgroundColor: "noIssuesBackground",
      textColor: "noIssuesText",
      value: i18n.t("views.ScavengerH2.tabs.noIssues.label"),
      tooltip: "",
    },
  ],
  gas_analysis: [
    {
      text: "Date",
      value: "date",
      of_type: "modal",
      identifier: "text",
    },
    {
      text: "H2* (ppm)",
      value: "h2",
      of_type: "text",
    },
    {
      text: "CH4* (ppm)",
      value: "ch4",
      of_type: "text",
    },
    {
      text: "C2H4* (ppm)",
      value: "c2h4",
      of_type: "text",
    },
    {
      text: "C2H6* (ppm)",
      value: "c2h6",
      of_type: "text",
    },
    {
      text: "C2H2* (ppm)",
      value: "c2h2",
      of_type: "text",
    },
    {
      text: "CO2 (ppm)",
      value: "co2",
      of_type: "text",
    },
    {
      text: "O2 (ppm)",
      value: "o2",
      of_type: "text",
    },
    {
      text: "N2 (ppm)",
      value: "n2",
      of_type: "text",
    },
    // {
    //   text: "Fault Zones",
    //   values: ["t1_error", "t2_error", "t3_error"],
    //   config: "duval_error",
    //   of_type: "icons",
    //   show_icons: true,
    // },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["Delete"],
      labels: ["Delete"],
    },
  ],
  messages_table_h2: [
    {
      align: "start",
      text: i18n.t("views.ScavengerH2Details.tables.messages.seqNo.text"),
      value: "seqNo",
      sortable: true,
      of_type: "text",
    },
    {
      text: i18n.t("views.ScavengerH2Details.tables.messages.messageTime.text"),
      value: "Timestamp",
      of_type: "epoch",
    },
    {
      value: "H2ppmCrt",
      of_type: "tooltip",
      text: i18n.t("views.ScavengerH2Details.tables.messages.h2Level.text"),
    },
    {
      value: "OilTemp",
      of_type: "tooltip",
      text: i18n.t("views.ScavengerH2Details.tables.messages.oilTemperature.text"),
    },
    {
      value: "H2ppmDayChg",
      of_type: "number",
      text: "H₂ppmDayChg",
    },
    {
      value: "H2ppmWeekChg",
      of_type: "number",
      text: "H₂ppmWeekChg",
    },
    {
      value: "H2ppmMonthChg",
      of_type: "number",
      text: "H₂ppmMonthChg",
    },
  ],
  device_details_h2: [
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.site.label"),
      value: "SiteName",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.xfmrId.label"),
      value: "AssetID",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.serialNumber.label"),
      value: "SerialNumber",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.opMode.label"),
      value: "OpMode",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.oilType.label"),
      value: "OilType",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.deviceStatus.label"),
      value: "DeviceStatus",
      type: "tooltip",
      tooltip_text: "Updated on ",
      tooltip_value: "StatusDate",
      tooltip_icon: "mdi-information-variant",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.alarmLimit.label"),
      value: "alarm",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.cautionLimit.label"),
      value: "caution",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.sensorType.label"),
      value: "SensorType",
    },
    {
      label: i18n.t("views.ScavengerH2Details.deviceDetails.sensorLocation.label"),
      value: "SensorLocation",
    },
  ],
  device_details_title: ["AssetID"],
  maps_config: {
    id: "DeviceID",
    infoText: "SiteName",
    label: "",
    lat: "CurrentLat",
    lng: "CurrentLng",
    url: "scavenger",
    datatype: "powerdata",
    type: "hasIssues",
  },
  infoWindowItemsConfig: [
    {
      id: "DeviceName",
      icon: "mdi-square-inc",
    },
    {
      id: "SerialNumber",
      icon: "mdi-view-sequential",
    },
    {
      id: "PowerRating",
      icon: "mdi-signal-distance-variant",
    },
    {
      id: "AssetID",
      icon: "mdi-cube-outline",
    },
    {
      id: "H2Lvl",
      icon: "mdi-chart-line-variant",
      suffix: "PPM",
    },
    {
      id: "FrequencyMean",
      icon: "mdi-wave",
      suffix: "Hz",
    },
    {
      id: "L1_RMSVoltageMean",
      icon: "mdi-flash",
      suffix: "V",
    },
    {
      id: "L2_RMSVoltageMean",
      icon: "mdi-flash",
      suffix: "V",
    },
    {
      id: "L3_RMSVoltageMean",
      icon: "mdi-flash",
      suffix: "V",
    },
  ],
  dga_maps_config: {
    id: "DeviceID",
    infoText: "SiteName",
    label: "",
    lat: "CurrentLat",
    lng: "CurrentLng",
    url: "scavenger_h2",
    datatype: "powerdata",
    type: "hasIssues",
  },
  time_filter: {
    label: "Time Filter",
    value: "timeFilter",
    options: [
      {
        text: i18n.t("common.times.time.last24Hours"),
        value: 1,
      },
      {
        text: i18n.t("common.times.time.last7Days"),
        value: 7,
      },
      {
        text: i18n.t("common.times.time.last28Days"),
        value: 28,
      },
    ],
  },
  longer_period_stats_chart: [
    [
      {
        id: "hydrogen",
        type: "line",
        label: "H₂ Level",
        max: "maxValue",
        min: "minValue",
        value: "avgValue",
        suffix: "ppm",
      },
      {
        id: "oil_temperature",
        type: "bar",
        label: "Liquid Temperature",
        max: "maxValue",
        min: "minValue",
        value: "avgValue",
        suffix: "°C",
      },
    ],
  ],
  scv_overview: [
    {
      id: "All",
      title: "All",
      icon: "mdi-sitemap",
      backgroundColor: "primary lighten-5",
      textColor: "primary",
      value: i18n.t("views.ScavengerOverview.tabs.all.label"),
      tooltip: "Total number of Devices",
      label: "Installed",
      suffix: ".",
    },
    {
      id: "PQ",
      title: "PQ",
      icon: "mdi-alert-circle-outline",
      backgroundColor: "secondary lighten-5",
      textColor: "secondary",
      value: i18n.t("views.ScavengerOverview.tabs.pq.label"),
      tooltip: "Devices with PQ issues",
      label: "Power Quality",
      suffix: " issues.",
    },
    {
      id: "H2",
      title: "H₂",
      icon: "mdi-chart-multiline",
      backgroundColor: "error lighten-5",
      textColor: "error",
      value: i18n.t("views.ScavengerOverview.tabs.h2.label"),
      tooltip: "Devices with H2 issues",
      label: "Hydrogen(H₂)",
      suffix: " issues.",
      pow: 2,
    },
  ],
  primary_filters: [
    {
      label: "All",
      value: "All",
    },
  ],
  secondary_filters: {
    range: [
      {
        label: "Message Reliability",
        min: 0,
        max: 100,
        value: "MessageReliability",
      },
      {
        label: "Capacity",
        min: 0,
        max: 1500,
        value: "Capacity",
      },
      {
        label: "Transformer Rating",
        min: 0,
        max: 1500,
        value: "TransformerRating",
      },
    ],
  },
  filters: {
    All: [
      [
        { value: "Capacity", label: "Capacity", suffix: "%" },
        { value: "TotalPower", label: "Total Power", suffix: "KVA" },
      ],
      [
        {
          value: "MessageReliability",
          label: "Message Reliability",
          suffix: "KVA",
          type: "bar",
        },
      ],
    ],
    PQ: [
      [
        {
          value: "Fault",
          label: "",
          suffix: "KVA",
          type: "icon",
          icon: "mdi-alert-circle-outline",
          color: "warning",
        },
        {
          value: "Faults",
          label: "Active Fault(s)",
          type: "list",
          cols: 9,
          color: "accent",
        },
      ],
      [
        {
          value: "LastGasp",
          label: "Loss of Mains",
          type: "date",
          icon: "mdi-alert-circle-outline",
          color: "lightCoral",
        },
      ],
    ],
    NZ: [
      [
        {
          value: "Capactity",
          label: "Capacity Today",
          suffix: "%",
          type: "vbar",
        },
        { value: "MaxCapacity7days", label: "Max Capacity over last 7 Days" },
        {
          value: "ProjectedCapacity",
          label: "Projected Capacity Yr",
        },
        { value: "MaxCapacity7days", label: "Max Capacity over last 7 Days" },
      ],
      [
        {
          value: "Rerating",
          label: "Rerating",
          type: "icon",
          icon: "mdi-sticker-alert-outline",
          color: "vtred",
        },
      ],
    ],
    TH: [
      [
        { value: "Temperature", label: "Temperature", suffix: "°C" },
        { value: "H2Lvl", label: "H2Lvl", suffix: "ppm" },
        { value: "H2RateOfChange", label: "H2RateOfChange", suffix: "°C" },
        { value: "TempRateOfChange", label: "TempRateOfChange", suffix: "ppm" },
      ],
      [{ value: "OverlaodRisk", label: "Overlaod Risk", type: "bar" }],
    ],
  },
  devices_all: [
    {
      align: "start",
      text: "XFMR ID",
      value: "AssetID",
      sortable: true,
      of_type: "modal",
      ctrl_click: true,
    },
    {
      text: "Site",
      value: "TransformerName",
      of_type: "text",
    },
    {
      text: "Transformer size",
      value: "TransformerRating",
      of_type: "text",
      suffix: " kVA",
    },
    {
      text: "Serial number",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Installation date",
      value: "StatusDate",
      of_type: "date",
    },
    {
      text: "Latest Readings",
      value: "LatestMessage",
      icon: "mdi-information-variant",
      values: [
        { value: "TotalPower", label: "Total Power", suffix: "KVA" },
        { value: "Capacity", label: "Capacity", suffix: "%" },
      ],
      of_type: "more_info",
    },
    {
      text: "Message Reliability",
      value: "MessageReliability",
      of_type: "perc",
      decimals: 0,
      tooltip: "% of messages received compared to the total expected messages.",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails", "OpenAsAPage"],
      labels: ["Edit Details", "Open as a Page"],
    },
  ],
  devices_nz: [
    {
      align: "start",
      text: "XFMR ID",
      value: "AssetID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Serial",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Capacity Today",
      value: "Capacity",
      of_type: "vbar",
    },
    {
      text: "Max capacity over last 7 days",
      value: "MaxCapacity7days",
      of_type: "number",
    },
    {
      text: "Projected capacity year",
      value: "ProjectedCapacity",
      of_type: "text",
    },
    {
      text: "Extreme weather",
      value: "extremeWeather",
      of_type: "number",
    },
    {
      text: "Rerating",
      value: "Rerating",
      of_type: "switch",
      icon: "mdi-sticker-alert-outline",
      color: "secondary",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  devices_pq: [
    {
      align: "start",
      text: "XFMR ID",
      value: "AssetID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Serial",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Site",
      value: "TransformerName",
      of_type: "text",
    },
    {
      text: "",
      value: "Fault",
      of_type: "switch",
      icon: "mdi-alert-circle-outline",
      color: "secondary",
    },
    {
      text: "Faults",
      value: "Faults",
      of_type: "list",
      color: "accent",
    },
    {
      text: "Loss of mains event",
      value: "LastGasp",
      of_type: "date",
      color: "lightCoral",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  devices_th: [
    {
      align: "start",
      text: "XFMR ID",
      value: "AssetID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Serial",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Temperature",
      value: "Temperature",
      of_type: "number",
      suffix: "°C",
    },
    {
      text: "Temp rate of change",
      value: "TempRateOfChange",
      of_type: "number",
    },
    {
      text: "Hydrogen level",
      value: "H2Lvl",
      of_type: "number",
    },
    {
      text: "H₂ rate of change ",
      value: "H2RateOfChange",
      of_type: "number",
    },
    {
      text: "Accelerated ageing",
      value: "AccAgeing",
      of_type: "number",
    },
    {
      text: "Overload Risk",
      value: "OverlaodRisk",
      of_type: "perc",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  devices_table: [
    {
      align: "start",
      text: "XFMR ID",
      value: "AssetID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Name",
      value: "TransformerName",
      of_type: "text",
    },
    {
      text: "Last Message Time",
      value: "Timestamp",
      of_type: "epoch",
    },
    {
      text: "L1_RMSVoltageMean",
      value: "L1_RMSVoltageMean",
      of_type: "number",
      suffix: "V",
    },
    {
      text: "L2_RMSVoltageMean",
      value: "L2_RMSVoltageMean",
      of_type: "number",
      suffix: "V",
    },
    {
      text: "L3_RMSVoltageMean",
      value: "L3_RMSVoltageMean",
      of_type: "number",
      suffix: "V",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails", "OpenAsAPage"],
      labels: ["Edit Details", "Open as a Page"],
    },
  ],
  devices_overview_select: [
    {
      label: "Today",
      value: "1",
    },
    {
      label: "This Week",
      value: "7",
    },
  ],
  faults_detected: {
    title: "Faults",
    tooltip: "Faults Detected",
    header: [
      "Faults Detected",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "OK",
        value: "Ok",
        msg: "Devices with no faults.",
      },
      {
        label: "Interrupt",
        value: "INTERRUPT",
        msg: "Devices with interruption.",
      },
      {
        label: "Last Gasp",
        value: "LAST_GASP",
        msg: "Devices with last gasp.",
      },
      {
        label: "Loss of Mains",
        value: "LOSS_OF_MAINS",
        msg: "Devices with loss of mains.",
      },
    ],
  },
  power_quality_issues: {
    title: "Overview",
    tooltip: "Power Quality Issues",
    header: [
      "Power Quality Issues",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "No Problem",
        value: "Ok",
        msg: "Devices with no known issues.",
      },
      {
        label: "Rapid Voltage Change",
        value: "RAPID_VOLTAGE_CHANGE",
        msg: "Devices  with rapid voltage change.",
      },
      {
        label: "Dip",
        value: "DIP",
        msg: "Devices with dip.",
      },
      {
        label: "Swell",
        value: "SWELL",
        msg: "Devices with swell.",
      },
    ],
  },
  compliance_issues: {
    title: "Compliance",
    tooltip: "Compliance Issues",
    header: [
      "Compliance Issues",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "No Problem",
        value: "Ok",
        msg: "Devices with no known issues.",
      },
      {
        label: "Voltage Threshold",
        value: "VOLTAGE_THRESHOLD",
        msg: "Devices with voltage threshold.",
      },
      {
        label: "Harmonics",
        value: "HARMONICS",
        msg: "Devices with harmonics.",
      },
      {
        label: "Reverse Power",
        value: "REVERSE_POWER",
        msg: "Devices with reverse power.",
      },
    ],
  },
  capacity_problems: {
    title: "Capacity",
    tooltip:
      "Capacity analysis measures the amount of capacity in use at each transformer and stratifies by overutilized, normal or underutilized.",
    header: [
      "Capacity",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Underutilized",
        value: "UNDERUTILIZED",
        msg: "Devices under current limit - Less than 15% Capacity",
      },
      {
        label: "Normal",
        value: "NORMAL",
        msg: "Devices with optimal current - Inbetween 15% and 85% Capacity ",
      },
      {
        label: "NA",
        value: "NA",
        msg: "Devices not yet installed.",
      },
      {
        label: "Overutilised",
        value: "OVERUTILIZED",
        msg: "Devices over current limit - More than 85% Capacity ",
      },
    ],
  },
  tabs: [
    {
      label: "Charts",
      id: "charts",
    },
    {
      label: "Raw Data",
      id: "messages",
    },
    {
      label: "Trends Data",
      id: "rms_data",
    },
    {
      label: "Events",
      id: "events",
    },
    {
      label: "Fault Records",
      id: "faults",
    },
    {
      label: "XFRMR Health",
      id: "xfrmr",
    },
    {
      label: "Metering",
      id: "metering",
    },
    {
      label: "Images",
      id: "images",
    },
    {
      label: "Reporting",
      id: "reporting",
    },
  ],
  device_details: [
    {
      label: "Transformer Name",
      value: "TransformerName",
    },
    {
      label: "Transformer  No.",
      value: "TransformerNo",
    },
    {
      label: "Transformer Rating",
      value: "TransformerRating",
      suffix: "kVA",
    },
    {
      label: "Asset ID",
      value: "AssetID",
    },
    {
      label: "Device Status",
      value: "DeviceStatus",
    },
    {
      label: "Monitor Type",
      value: "MonitorType",
    },
    {
      label: "Last Status Update",
      value: "StatusDate",
      type: "date",
    },
  ],
  table_pagination: [5, 10, 25, 50],
  events: {
    LOSS_OF_MAINS: "Fault",
    INTERRUPT: "Event",
    RAPID_VOLTAGE_CHANGE: "Event",
    DIP: "Event",
    SWELL: "Event",
    FLICKER: "Event",
  },
  event_types: {
    LOSS_OF_MAINS: {
      id: "LOSS_OF_MAINS",
      label: "Loss of Mains",
      icon: "mdi-power-off",
      textColor: "pink darken-4",
      textColorHEX: "#880E4F",
      backgroundColor: "pink lighten-5",
      backgroundColorHEX: "#FCE4EC",
      svg_path:
        "M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M12,19A7,7 0 0,1 5,12A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19Z",
      show: true,
    },
    INTERRUPT: {
      id: "INTERRUPT",
      label: "Interrupt",
      icon: "mdi-power-plug-off",
      textColor: "indigo darken-3",
      textColorHEX: "#283593",
      backgroundColor: "indigo lighten-5",
      backgroundColorHEX: "#E8EAF6",
      svg_path:
        "M20.84 22.73L15.31 17.2L14.5 18V21H9.5V18L6 14.5V9C6 8.7 6.1 8.41 6.25 8.14L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M18 14.5V9C18 8 17 7 16 7V3H14V7H10.2L17.85 14.65L18 14.5M10 3H8V4.8L10 6.8V3Z",
      show: true,
    },
    RAPID_VOLTAGE_CHANGE: {
      id: "RAPID_VOLTAGE_CHANGE",
      label: "Variation",
      icon: "mdi-flash-alert",
      textColor: "deep-purple darken-3",
      textColorHEX: "#4527A0",
      backgroundColor: "deep-purple lighten-4",
      backgroundColorHEX: "#D1C4E9",
      svg_path: "M5,2V13H8V22L15,10H11L15,2M17,15H19V17H17V15M17,7H19V13H17V7Z",
      show: true,
    },
    DIP: {
      id: "DIP",
      label: "Dip",
      icon: "mdi-trending-down",
      textColor: "red darken-2",
      textColorHEX: "#D32F2F",
      backgroundColor: "red lighten-4",
      backgroundColorHEX: "#FFCDD2",
      svg_path: "m16,18l2.29,-2.29l-4.88,-4.88l-4,4l-7.41,-7.42l1.41,-1.41l6,6l4,-4l6.3,6.29l2.29,-2.29l0,6l-6,0z",
      show: true,
    },
    SWELL: {
      id: "SWELL",
      label: "Swell",
      icon: "mdi-trending-up",
      textColor: "blue darken-3",
      textColorHEX: "#1565C0",
      backgroundColor: "blue lighten-4",
      backgroundColorHEX: "#BBDEFB",
      svg_path: "M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z",
      show: true,
    },
    FLICKER: {
      id: "FLICKER",
      label: "Flicker",
      icon: "mdi-lightbulb-on",
      textColor: "amber darken-3",
      textColorHEX: "#FF8F00",
      backgroundColor: "amber lighten-4",
      backgroundColorHEX: "#FFECB3",
      svg_path:
        "M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z",
      show: true,
    },
    UNKNOWN: {
      id: "UNKNOWN",
      label: "Unknown Event Type",
      icon: "mdi-help",
      textColor: "brown darken-4",
      textColorHEX: "#3E2723",
      backgroundColor: "brown lighten-4",
      backgroundColorHEX: "#D7CCC8",
      svg_path:
        "M10,19H13V22H10V19M12,2C17.35,2.22 19.68,7.62 16.5,11.67C15.67,12.67 14.33,13.33 13.67,14.17C13,15 13,16 13,17H10C10,15.33 10,13.92 10.67,12.92C11.33,11.92 12.67,11.33 13.5,10.67C15.92,8.43 15.32,5.26 12,5A3,3 0 0,0 9,8H6A6,6 0 0,1 12,2Z",
      show: false,
    },
  },
};

export { content };
